import { AnalyticsEventTracker } from "src/app/nutrigenic/models/analytics-event-tracker.model";

export class BeginCheckoutEventTracker implements AnalyticsEventTracker {
  constructor(private eventName: string) {
    this.eventName = eventName;
  }

  getProcessedData(rawEventData: any) {
    console.log(rawEventData);
    if (!rawEventData) return;
    console.log(rawEventData);
    const event = {
      ecommerce: {
        /*value: rawEventData.reduce(
          (accumulator: number, currentValue: any) =>
            accumulator + currentValue.value * currentValue.quantity,
          0
        ),*/
        currency: 'GBP',
        value: rawEventData.ecommerce.value,
        items: rawEventData.ecommerce.items
        /*items: rawEventData.map((item: any) => ({
          item_id: item.id,
          item_name: item.title,
          item_category: item.title,
          quantity: Number(item.quantity),
          price: item.value,
        })),*/
      },
    };

    return {
      eventData: event,
    };
  }
}
